import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, change  } from 'redux-form';
import { Grid } from './../../../assets/theme/layout';
import { Content, Button, ButtonsGroup } from './../../../components/ui';
import { InputTextField, SelectField, OptionField } from './../../../components/ui/input';
import { stringifyQueryString, parseQueryString } from './../../../utilities/utils';

class UtilClientFilter extends React.Component {

  componentDidMount(){

    const search = parseQueryString(this.props.location.search);

    Object.entries(search).forEach(([key,value]) => {
      this.props.dispatch(change(this.props.form, key, value));
    });

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  handleSubmitForm = (values) => {
    console.log(values);
    this.props.history.push(`/clients?${ stringifyQueryString(values) }`);
    this.props.onSuccess();
  }

  render() {

    const { handleSubmit } = this.props;

    return(

      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

        <Content disablePadding divider>
          <Grid container spacing={3}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Field
                  name="identifire"
                  component={ InputTextField }
                  label={this.props.t('field.document_number')}
                  type="text"
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="name"
                  component={ InputTextField }
                  label={this.props.t('field.name')}
                  type="text"
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="surname"
                  component={ InputTextField }
                  label={this.props.t('field.surname')}
                  type="text"
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="email"
                  component={ InputTextField }
                  label="Email"
                  type="text"
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="status"
                  component={ SelectField }
                  label={this.props.t('field.status')}>
                    <OptionField value="none">{this.props.t('field.option_field.all')}</OptionField>
                    <OptionField value="enabled">{this.props.t('field.option_field.active')}</OptionField>
                    <OptionField value="disabled">{this.props.t('field.option_field.disabled')}</OptionField>
                    <OptionField value="removed">{this.props.t('field.option_field.removed')}</OptionField>
              </Field>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="registered"
                  component={ SelectField }
                  label={this.props.t('field.registered')}>
                    <OptionField value="none">{this.props.t('field.option_field.all')}</OptionField>
                    <OptionField value="enabled">{this.props.t('field.option_field.yes')}</OptionField>
                    <OptionField value="disabled">{this.props.t('field.option_field.no')}</OptionField>
              </Field>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <Field
                  name="verified"
                  component={ SelectField }
                  label={this.props.t('field.verified')}>
                    <OptionField value="none">{this.props.t('field.option_field.all')}</OptionField>
                    <OptionField value="enabled">{this.props.t('field.option_field.yes')}</OptionField>
                    <OptionField value="disabled">{this.props.t('field.option_field.no')}</OptionField>
              </Field>
            </Grid>
          </Grid>
        </Content>

        <Content disablePadding>
          <ButtonsGroup align="right">
            <Button aria-label="Aplicar" icon="save" color="primary" type="submit">
              {this.props.t('button.apply')}
            </Button>
          </ButtonsGroup>
        </Content>

      </form>

    )
  }

}

UtilClientFilter = reduxForm({
  form: 'UtilClientFilter',
  initialValues: {
    enabled: 'none'
  },
  enableReinitialize: true
})(UtilClientFilter);

export default withTranslation()(withRouter(UtilClientFilter));
